import React, { useContext, useMemo, useState, ReactNode } from "react";
import { useTextDomainContext } from "@/app/providers";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Fade from "@mui/material/Fade";
import MenuItem from "@mui/material/MenuItem";
import { arrayOf, object, node, func } from "prop-types";

const timestamp = Date.now();
const randomString = Math.random().toString();

type ToolbarDropdownOption = {
  key: string;
  label?: string;
  url?: string;
  [key: string]: unknown;
};

type ToolbarDropdownProps = {
  data?: ToolbarDropdownOption[];
  endIcon?: ReactNode;
  onClick?: (obj: ToolbarDropdownOption) => void;
  label?: ReactNode;
};

export const ToolbarDropdown = (props: ToolbarDropdownProps) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const data = useMemo(() => {
    return props.data ?? [];
  }, [props.data]);

  const endIcon = useMemo(() => {
    return props.endIcon ?? undefined;
  }, [props.endIcon]);

  const label = useMemo(() => {
    return props.label ?? gettext("Export");
  }, [gettext, props.label]);

  // const fileName = useMemo(() => {
  //   return props.fileName ?? "export";
  // }, [props.fileName]);

  // const [data, setData] = useState(typeof props.data === "undefined" ? [] : props.data);
  // const [fileName, setFileName] = useState(typeof props.fileName === "undefined" ? "export" : props.fileName);

  // useEffect(() => {
  //   if (typeof props.data !== "undefined") {
  //     setData(props.data);
  //   }
  // }, [props.data]);

  // useEffect(() => {
  //   if (typeof props.fileName !== "undefined") {
  //     setFileName(props.fileName);
  //   }
  // }, [props.fileName]);

  // useEffect(() => {
  //   data.forEach((obj) => {
  //     console.log(obj.label);
  //   });
  // }, [data]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleExportToExcel = (url) => {
  //   const win = window.open(url, "_blank");
  //   win.focus();
  //   handleClose();
  // };

  const handleClickOption = (obj: ToolbarDropdownOption) => {
    if (obj.url) {
      const win = window.open(obj.url + "?" + timestamp, "_blank");
      win.focus();
    }

    if (typeof props.onClick === "function") {
      props.onClick(obj);
    }

    handleClose();
  };

  // const handleExportToCsv = () => {
  //   ExportToCsv(data, `${fileName}.csv`);
  //   handleClose();
  // };

  // const handleExportToPdf = () => {
  //   ExportToPdf(data, `${fileName}.pdf`);
  //   handleClose();
  // };

  return (
    <>
      <Button
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={endIcon}
        disabled={!data?.length}
        sx={{
          ml: 1,
          color: "grey.600",
          fontWeight: 400,
        }}
      >
        <>{label}</>
      </Button>
      <Menu
        id="fade-menu"
        slotProps={{
          list: {
            "aria-labelledby": "fade-button",
          },
        }}
        slots={{
          transition: Fade,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {data.map((obj: ToolbarDropdownOption) => (
          <MenuItem
            key={obj?.label || randomString} // Assuming obj.label is unique, if not, use another unique identifier
            onClick={() => handleClickOption(obj)}
            sx={{
              fontSize: "0.875rem",
              color: "grey.600",
              fontWeight: 300,
            }}
          >
            {obj?.label}
          </MenuItem>
        ))}

        {/*<MenuItem*/}
        {/*  onClick={handleExportToPdf}*/}
        {/*  sx={{*/}
        {/*    fontSize: "0.875rem",*/}
        {/*    color: "grey.600",*/}
        {/*    fontWeight: 300*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {gettext("export to PDF")}*/}
        {/*</MenuItem>*/}
      </Menu>
    </>
  );
};

ToolbarDropdown.propTypes = {
  data: arrayOf(object),
  endIcon: node,
  onClick: func,
  label: node,
};
